<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">用户名</p>
        <el-input v-model="userName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">角色</p>
        <el-select v-model="roleName" placeholder="请选择账号角色" clearable>
          <el-option v-for="item in roleValueList" :key="item.roleName" :label="item.roleName" :value="item.roleName"> </el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">状态</p>
        <el-select v-model="stateValue" placeholder="请选择状态" clearable>
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </div>
      <div class="stateDiv" v-if="isCurrentCompany">
        <p class="searchText">公司</p>
        <el-select v-model="companyId" placeholder="请选择所属公司" clearable >
          <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName" :value="item.companyId"> </el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">部门</p>
        <el-select  clearable id="selectInput" @clear="dataFilter" v-model="deptName" filterable placeholder="请选择/输入" ref="searchSelect" :filter-method="(val) => dataFilter(val, index)">
          <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addAccount">新增账号</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{ prop: 'id', order: 'descending' }" style="width: 100%" :highlight-current-row="false" :header-cell-style="{ background: '#F4F7FA', color: '#606266' }">
          <template v-for="(item, index) in tableColumns">
            <el-table-column v-if="item.prop === 'enableStatus'" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.enableStatus === 1 ? '启用' : '禁用' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.prop === 'companyName'" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.userCompanyRelList" :key="index">
                  {{ item.companyName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.prop === 'deptName'" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.userCompanyRelList" :key="index">
                  {{ item.deptName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.prop === 'chineseName'" :key="index" :prop="item.prop" :label="item.label" :width="item.width">
              <template slot-scope="scope">
                  <el-link class="tableBtn" @click="viewOrHandle(scope.row, 'view')" type="primary" size="small">{{scope.row.chineseName}}</el-link>
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter" :width="item.width"> </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row, 'edit')" type="text" size="small">编辑</el-button>
              <!-- <el-button class="tableBtn" @click="changePassword(scope.row)" type="text" size="small">修改密码</el-button> -->
              <!-- <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody"> </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeAdd" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="140px" autocomplete="off" :disabled="viewShow">
          <el-form-item label="用户名" prop="userName" class="formItem">
            <el-input v-model="addForm.userName" clearable :disabled="edit" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="chineseName" class="formItem">
            <el-input v-model="addForm.chineseName" clearable :disabled="edit" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="工号" prop="workno" class="formItem">
            <el-input v-model="addForm.workno" clearable placeholder="请输入工号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="密码" v-if="!edit" prop="password" class="formItem">
            <el-input v-model="addForm.password" type="password" show-password clearable autocomplete= "new-password"></el-input>
          </el-form-item> -->
          <el-form-item label="手机号" prop="mobile" class="formItem">
            <el-input v-model="addForm.mobile" type="mobile" clearable placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCardNo" class="formItem">
            <el-input v-model="addForm.idCardNo" type="idCardNo" clearable placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="年假设置"  prop="vacationCount" class="formItem">
            <el-input-number v-model="addForm.vacationCount"  :min="0" :max="100" label="描述文字" style="width:90%;margin-right:5px" :controls="false"></el-input-number>天
          </el-form-item> -->
          <el-form-item label="账号角色" prop="roleName" class="formItem">
            <el-select v-model="addForm.roleName" placeholder="请选择账号角色" style="width: 100%">
              <el-option v-for="item in roleValueList" :key="item.roleName" :label="item.roleName" :value="item.roleName"> </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item class="formItem">
            <i class="el-icon-circle-plus-outline" style="font-size: 24px" @click="addCompanyDept"  v-if="!viewShow"/>
          </el-form-item> -->

          <div v-for="(item, index) in addForm.userCompanyRelList" :key="index">
            <el-row style="display: flex; align-items: center">
              <el-col :span="22">
                <el-form-item label="所属公司" :prop="'userCompanyRelList.' + index + '.companyId'" :rules="{ required: true, message: '请选择公司', trigger: 'change' }">
                  <el-select v-model="item.companyId" placeholder="请选择所属公司" clearable style="width: 100%">
                    <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName" :value="item.companyId"> </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属部门" :prop="'userCompanyRelList.' + index + '.deptName'" :rules="{ required: true, message: '请选择部门', trigger: 'change' }">
                  <el-select style="width: 100%" clearable id="selectInput" @clear="dataFilter" v-model="item.deptName" filterable placeholder="请选择/输入" ref="searchSelect" :filter-method="(val) => dataFilter(val, index)">
                    <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="!viewShow && index === 0">
                <i class="el-icon-circle-plus-outline" style="font-size: 24px; margin-bottom: 15px; cursor: pointer;" @click="addCompanyDept" />
              </el-col>
              <el-col :span="2" v-if="index > 0 && !viewShow">
                <i class="el-icon-remove-outline" @click="deleteCompanyDept(index)"  style="font-size: 24px; margin-bottom: 15px; cursor: pointer;" />
              </el-col>
            </el-row>
          </div>
          <!-- <el-form-item label="是否为部门负责人">
            <el-radio-group v-model="addForm.deptLeaderFlag">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="查看所有公司数据">
            <el-radio-group v-model="addForm.allDataAccessFlag">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="账号状态" prop="state">
            <el-radio-group v-model="addForm.state">
              <el-radio label="1">启用</el-radio>
              <el-radio label="0">禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm()" v-if="!viewShow">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog :title="eventControl" :visible.sync="passwordFormVisible" :before-close="closeChange" center>
      <el-form :model="passwordForm" :rules="rules" ref="passwordForm">
        <el-form-item label="用户名" label-width="120px" prop="userName">
          <el-input v-model="passwordForm.userName" disabled auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" label-width="120px" prop="password">
          <el-input v-model="passwordForm.password" placeholder="请填写" type="password" autocomplete="off" maxlength="32"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeChange">取 消</el-button>
        <el-button type="primary" @click="changePasswordEvent">修 改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listCompanyfInfo, listRoleInfo } from '@/api/searchList'
import { addUserInfo, queryUserInfo, queryIdUserInfo, updateUserInfo, deleteUserInfo, changeUserPassword } from '@/api/basicInfo'
import { listDeptNameList } from '@/api/user'
import { validPhone, vaildIDCard } from '@/assets/scripts/validate'
import { Message } from 'element-ui'
import md5 from 'md5'
export default {
  name: 'accountPage',
  data() {
    return {
      loading: false,
      viewShow: false,
      roleName: '',
      userName: '',
      roleValueList: [],
      companyValueList: [],
      stateValue: '',
      companyId: '',
      deptName: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      passwordFormVisible: false,
      eventControl: '',
      edit: false,
      passwordForm: {},
      addForm: {
        userName: '',
        password: 'admin@123',
        roleName: '',
        companyId: '',
        remark: '',
        state: '',
        vacationCount: '',
        mobile: '',
        idCardNo: '',
        allDataAccessFlag: 0,
        chineseName: '',
        deptName: '',
        deptLeaderFlag: 1,
        workno: '',
        userCompanyRelList: [
          {
            companyId: '',
            deptName: ''
          }
        ]
      },
      rules: {
        workno: [{ required: true, message: '请填写', trigger: 'blur' }],
        deptName: [
          { required: true, message: '请选择/输入', trigger: 'blur' },
          { required: true, message: '请选择/输入', trigger: 'change' }
        ],
        chineseName: [{ required: true, message: '请填写', trigger: 'blur' }],
        userName: [{ required: true, message: '请填写', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请填写', trigger: 'blur' },
          { validator: validPhone, trigger: 'blur' }
        ],
        idCardNo: [
          { required: true, message: '请填写', trigger: 'blur' },
          { validator: vaildIDCard, trigger: 'blur' }
        ],
        vacationCount: [{ required: true, message: '请填写', trigger: 'blur' }],
        // password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { validator: validPassword, trigger: 'blur' }],
        roleName: [{ required: true, message: '请选择', trigger: 'blur' }],
        companyId: [{ required: true, message: '请选择', trigger: 'blur' }],
        state: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'userName',
          label: '用户名'
        },
        {
          prop: 'chineseName',
          label: '姓名'
        },
        {
          prop: 'idCardNo',
          label: '身份证号'
        },
        {
          prop: 'mobile',
          label: '手机号'
        },
        {
          prop: 'roleName',
          label: '角色'
        },
        {
          prop: 'companyName',
          label: '所属公司'
          // formatter: (row, column, v) => {
          //   return this.companyValueList.find(v2 => v2.companyId === v).companyName
          // }
        },
        {
          prop: 'deptName',
          label: '部门'
        },
        {
          prop: 'enableStatus',
          label: '账号状态'
        },
        {
          prop: 'remark',
          label: '备注'
        }
      ],
      deptNameList: [],
      groupCompanyId: 0,
      optionsFilter: []
    }
  },
  mounted() {
    this.getData()
    this.getDept()
    this.getCompanyList()
    this.getRoleValueList()
  },
  computed: {
    sonDataAuth() {
      return this.addForm.userCompanyRelList.some((v) => v.companyId === this.groupCompanyId)
    },
    isCurrentCompany() {
      // 判断登录是否为当前总公司
      return JSON.parse(this.$base.getLocalStorage('current_company')).companyName === process.env.VUE_APP_COMPANY_NAME
    }
  },
  methods: {
    addCompanyDept() {
      this.addForm.userCompanyRelList.push({
        companyId: '',
        deptName: ''
      })
    },
    deleteCompanyDept(index) {
      this.addForm.userCompanyRelList.splice(index, 1)
    },
    async getDept() {
      const { result } = await listDeptNameList()
      this.deptNameList = result
      this.optionsFilter = result
    },
    dataFilter(val, index) {
      console.log(val, 'val')
      if (val) {
        this.addForm.userCompanyRelList[index].deptName = val
        this.deptNameList = this.optionsFilter.filter((item) => {
          if (item.includes(val) || item.toUpperCase().includes(val.toUpperCase())) {
            return true
          } else {
            this.$nextTick(() => {
              this.$refs['addForm'].clearValidate('deptName')
            })
          }
        })
      } else {
        this.deptNameList = this.optionsFilter
      }
    },
    // 公司下拉框
    async getCompanyList() {
      let res = await listCompanyfInfo({})
      if (res.code === 0) {
        this.companyValueList = res.result
        this.groupCompanyId = res.result.filter(v => v.companyName === process.env.VUE_APP_COMPANY_NAME)[0].companyId
      }
    },
    // 角色下拉框
    async getRoleValueList() {
      let res = await listRoleInfo({})
      if (res.code === 0) {
        this.roleValueList = res.result
      }
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await queryUserInfo({
        userName: this.userName,
        roleName: this.roleName,
        enableStatus: this.stateValue,
        companyId: this.companyId,
        deptName: this.deptName,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addAccount() {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增账号'
    },
    async viewOrHandle(row, type) {
      this.edit = true
      if (type === 'view') {
        this.viewShow = true
        this.eventControl = '查看账号信息'
      } else {
        this.viewShow = false
        this.eventControl = '编辑账号'
      }
      let res = await queryIdUserInfo({
        id: row.id
      })
      if (res.code === 0) {
        if (res.result.companyName === null) {
          this.addForm.companyId = null
        } else {
          this.addForm.companyId = res.result.companyId
        }
        this.addForm.userName = res.result.userName
        this.addForm.password = 'Abc!1234'
        this.addForm.roleName = res.result.roleName
        // this.addForm.companyId = res.result.companyId
        this.addForm.remark = res.result.remark
        this.addForm.state = res.result.enableStatus.toString()
        this.id = row.id
        this.addForm.workno = res.result.workno
        this.addForm.chineseName = res.result.chineseName
        this.addForm.mobile = res.result.mobile
        this.addForm.idCardNo = res.result.idCardNo
        this.addForm.allDataAccessFlag = res.result.allDataAccessFlag
        this.addForm.vacationCount = res.result.vacationCount
        this.addForm.deptName = res.result.deptName
        this.addForm.deptLeaderFlag = res.result.deptLeaderFlag
        this.addForm.userCompanyRelList = res.result.userCompanyRelList
      }
      this.dialogFormVisible = true
    },
    closeAdd() {
      this.dialogFormVisible = false
      this.viewShow = false
      this.$refs['addForm'].resetFields()
      this.addForm = {
        userName: '',
        chineseName: '',
        workno: '',
        password: '',
        roleName: '',
        companyId: '',
        remark: '',
        mobile: '',
        idCardNo: '',
        allDataAccessFlag: 0,
        deptName: '',
        state: '',
        userCompanyRelList: [
          {
            companyId: '',
            deptName: ''
          }
        ]
      }
    },
    changePassword(row) {
      this.eventControl = '修改密码'
      this.passwordForm.userName = row.userName
      this.passwordFormVisible = true
    },
    // 关闭修改密码弹窗
    closeChange() {
      this.passwordFormVisible = false
      this.$refs['passwordForm'].resetFields()
      this.passwordForm = {}
    },
    changePasswordEvent() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          let res = await changeUserPassword({
            userName: this.passwordForm.userName,
            newPwd: this.$base.randomString(3) + md5(this.passwordForm.password) + this.$base.randomString(3)
          })
          if (res.code === 0) {
            Message.success('修改成功！')
            this.passwordFormVisible = false
          }
        }
      })
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await updateUserInfo({
              userName: this.addForm.userName,
              workno: this.addForm.workno,
              vacationCount: this.addForm.vacationCount,
              chineseName: this.addForm.chineseName,
              mobile: this.addForm.mobile,
              idCardNo: this.addForm.idCardNo,
              allDataAccessFlag: this.addForm.allDataAccessFlag,
              roleName: this.addForm.roleName,
              companyId: this.addForm.companyId,
              enableStatus: this.addForm.state,
              remark: this.addForm.remark,
              deptName: this.addForm.deptName,
              deptLeaderFlag: this.addForm.deptLeaderFlag,
              id: this.id,
              userCompanyRelList: this.addForm.userCompanyRelList.map((v) => {
                return {
                  companyId: v.companyId,
                  deptName: v.deptName
                }
              })
            })
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.dialogFormVisible = false
              this.viewShow = false
              this.$refs['addForm'].resetFields()
              this.addForm = {
                userName: '',
                workno: '',
                vacationCount: '',
                chineseName: '',
                mobile: '',
                idCardNo: '',
                allDataAccessFlag: 0,
                password: '',
                roleName: '',
                companyId: '',
                remark: '',
                deptName: '',
                deptLeaderFlag: 1,
                state: '',
                userCompanyRelList: [
                  {
                    companyId: '',
                    deptName: ''
                  }
                ]
              }
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await addUserInfo({
              userName: this.addForm.userName,
              password: this.$base.randomString(3) + md5(this.addForm.password) + this.$base.randomString(3),
              roleName: this.addForm.roleName,
              companyId: this.addForm.userCompanyRelList[0].companyId || '',
              enableStatus: this.addForm.state,
              remark: this.addForm.remark,
              workno: this.addForm.workno,
              chineseName: this.addForm.chineseName,
              mobile: this.addForm.mobile,
              idCardNo: this.addForm.idCardNo,
              allDataAccessFlag: this.addForm.allDataAccessFlag,
              deptName: this.addForm.userCompanyRelList[0].deptName || '',
              deptLeaderFlag: this.addForm.deptLeaderFlag,
              vacationCount: this.addForm.vacationCount,
              userCompanyRelList: this.addForm.userCompanyRelList.map((v) => {
                return {
                  companyId: v.companyId,
                  deptName: v.deptName
                }
              })
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.viewShow = false
              this.addForm = {
                userName: '',
                workno: '',
                vacationCount: '',
                mobile: '',
                idCardNo: '',
                allDataAccessFlag: 0,
                chineseName: '',
                password: '',
                roleName: '',
                companyId: '',
                remark: '',
                deptName: '',
                deptLeaderFlag: 1,
                state: '',
                userCompanyRelList: [
                  {
                    companyId: '',
                    deptName: ''
                  }
                ]
              }
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
          this.getDept()
        }
      })
    },
    // 删除用户
    deleteFun(row) {
      this.$confirm('此操作将删除改账号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          id: row.id
        }
        let res = await deleteUserInfo(params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  // height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: 0.3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: 0.3rem;
    /*padding-top: 0.1rem;*/
  }
}

.table {
  margin-top: 0.3rem;
  margin-left: 0.5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {
  }

  .paginationBody {
    margin-top: 0.1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog {
  width: 30% !important;
}
</style>
